// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__3B0Zu","error":"InputSecondary_error__3ssbB","disabled":"InputSecondary_disabled__20LMV"};